var React = require('react');

function Dtop (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.8","d":"M122.443 190H0.285156L49.4504 -0.000121748H159.965C163.53 -0.00071458 167.048 0.816775 170.248 2.38949C173.448 3.96221 176.245 6.24826 178.424 9.07187C180.603 11.8955 182.106 15.1815 182.817 18.6771C183.528 22.1728 183.428 25.7851 182.526 29.2362L145.003 172.587C143.696 177.577 140.772 181.992 136.69 185.143C132.608 188.293 127.598 190.001 122.443 190Z","fill":"#0000FF"}));
}

Dtop.defaultProps = {"width":"184","height":"190","viewBox":"0 0 184 190","fill":"none"};

module.exports = Dtop;

Dtop.default = Dtop;
